import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { clsx } from 'clsx';

import * as styles from './AnimatedContainer.css';

interface IAnimatedContainerProps {
  children: React.ReactNode;
  className?: string;
  percentVisible?: number;
  timeoutCallback?: number;
  isAnimationAvailable?: boolean;
}

export const AnimatedContainer: React.FC<IAnimatedContainerProps> = ({
  children,
  percentVisible = 0.2,
  timeoutCallback = 0,
  isAnimationAvailable = true,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [isAnimated, setIsAnimated] = React.useState(false);

  React.useEffect(() => {
    // Принудительная проверка — виден ли элемент уже при монтировании
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const inView = rect.top < windowHeight && rect.bottom >= 0;

      if (inView) {
        setIsAnimated(true);
      }
    }
  }, []);

  return (
    <ActionAfterViewed
      percentVisible={percentVisible}
      timeoutCallback={timeoutCallback}
      callback={() => {
        setIsAnimated(true);
      }}
    >
      <div
        ref={ref}
        className={clsx(
          styles['container'],
          isAnimated && styles['animated'],
          !isAnimationAvailable && styles['force-appearance'],
        )}
      >
        {children}
      </div>
    </ActionAfterViewed>
  );
};
